//
//
//
//
//
//
//
//
//
//

// 未知错误组件
export default {
  name: 'UnknownError',
  data: function data() {
    return {
      title: '未知错误组件'
    };
  },
  props: {},
  created: function created() {},
  destroyed: function destroyed() {},
  methods: {
    refresh: function refresh() {
      this.$emit('refreshEvent');
    }
  }
};